
const colors = {
  bgLight: "#fff",
  primartLight: "#319795",
  bgDark: "#1A202C",
  primaryDark: "#81E6D9",
}

export default colors